'use strict';

function isFormDataObject(value) {
    if (Array.isArray(value) ||
        value == null ||
        typeof value !== 'object' ||
        value instanceof Blob) {
        return false;
    }
    return true;
}
function buildRequestFormData(bodyParameters) {
    const keys = Object.keys(bodyParameters);
    if (keys.length === 0) {
        return undefined;
    }
    const singleValue = bodyParameters[keys[0]];
    return keys.length === 1 && isFormDataObject(singleValue)
        ? singleValue
        : bodyParameters;
}
function convertToFormData(payload) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
        if (Array.isArray(value)) {
            for (const element of value) {
                addDataToFormData(formData, key, element);
            }
        }
        else {
            addDataToFormData(formData, key, value);
        }
    }
    return formData;
}
function addDataToFormData(formData, key, value) {
    if (value == null) {
        return;
    }
    if (value instanceof Blob) {
        formData.append(key, value);
    }
    else if (typeof value === 'object') {
        // Note(mnh): Form data is only key/value - any nested objects will
        // have to be serialized and deserialized on the backed using model
        // binding
        formData.append(key, JSON.stringify(value));
    }
    else {
        formData.append(key, value);
    }
}

exports.buildRequestFormData = buildRequestFormData;
exports.convertToFormData = convertToFormData;
//# sourceMappingURL=buildRequestFormData.js.map
